import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=48357e7a&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=48357e7a&prod&scoped=true&lang=scss"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=48357e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48357e7a",
  null
  
)

export default component.exports